module.exports = __webpack_public_path__ + "static/media/edu.c207ed50.png";